import App from './app.svelte';

const target = document.getElementById("inside-idaho-search-app");

const app = new App({
  target: target
});

export default app;